import { JsonElementType, JsonObject, JsonProperty, JsonType } from "ta-json";

import type { Nullable } from "../../base-types";
import Link from "../../link";
import Resource from "../resource";
import { MemberPolicyResource } from "./member-policy-resource";
import { RuleResource } from "./rule-resource";

/**
 * Policy resource.
 */
@JsonObject()
export class PolicyResource extends Resource {
    /**
     * Non null collection of rules for the policy.
     *
     * @remarks
     * If any of the rules apply in the specific case the policy is triggered (i.e. rules are combined with "OR" logical
     * operator).
     */
    @JsonProperty("rules")
    @JsonElementType(RuleResource)
    rules: Array<RuleResource> = [];

    /**
     * Non null collection of the member security policies.
     */
    @JsonProperty("member_security")
    @JsonElementType(MemberPolicyResource)
    memberSecurity: Array<MemberPolicyResource> = [];

    /**
     * Non null collection of the member group security policies.
     */
    @JsonProperty("membergroup_security")
    @JsonElementType(MemberPolicyResource)
    memberGroupSecurity: Array<MemberPolicyResource> = [];

    /**
     * Link to user resource or null if not applicable.
     */
    @JsonProperty("user")
    @JsonType(Link)
    user?: Nullable<Link>;

    /**
     * Link to the user group resource or null if not applicable.
     */
    @JsonProperty("usergroup")
    @JsonType(Link)
    userGroup?: Nullable<Link>;

    /**
     * Link to the user resource representing who created the policy.
     */
    @JsonProperty("created_by")
    readonly createdBy: Link;

    /**
     * Time of the policy creation.
     */
    @JsonProperty("created_on")
    readonly createdOn: Date;

    /**
     * Link to the user resource representing who last modified the policy.
     */
    @JsonProperty("modified_by")
    readonly modifiedBy: Link;

    /**
     * Time of the last policy modification.
     */
    @JsonProperty("modified_on")
    readonly modifiedOn: Date;
}
